module.exports = __webpack_public_path__ + "static/2front-development-1-49ab61bdd53d61a5b271b38df5ac302d.png";